import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  CreateUpdateFloorPlanItemRequest,
  FloorPlanItem,
  FloorPlanNewObject,
  FloorPlanNewSection,
  FloorPlanNewTable,
  FloorPlanObject,
  FloorPlanSection,
  FloorPlanTable,
  TableAttributes,
} from '@shared/floor-plan/models';
import { FloorPlanItemType } from '@shared/floor-plan/enums';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({providedIn: 'root'})
export class FloorPlanItemApiService {
  private readonly basePath = '/v.1/floor-plan/item';

  constructor(private readonly http: ApiClientService) { }

  getListForId(floorPlanId: string): Observable<FloorPlanItem[]> {
    return this.http.get<FloorPlanItem[]>(`${this.basePath}/${floorPlanId}`);
  }

  // TODO: think out signature and rework
  create(floorPlanId: string, data: FloorPlanNewTable | FloorPlanNewObject | FloorPlanNewSection): Observable<FloorPlanItem> {
    const _data: CreateUpdateFloorPlanItemRequest = {
      type: data.type,
      name: data.name,
      attributes: data.getAttributes(),
    } as unknown as CreateUpdateFloorPlanItemRequest;

    return this.http.post<FloorPlanItem>(`${this.basePath}/${floorPlanId}`, _data);
  }

  updatePartialById(id: string, type: FloorPlanItemType, attributes: Partial<TableAttributes>): Observable<FloorPlanItem> {
    if (!id) {
      throw new Error('Id is required.')
    }

    const _data: CreateUpdateFloorPlanItemRequest = {
      type,
      attributes,
    } as unknown as CreateUpdateFloorPlanItemRequest;

    return this.http.patch<FloorPlanItem>(`${this.basePath}/${id}/attributes`, _data);
  }

  updateById(data: FloorPlanTable | FloorPlanObject | FloorPlanSection): Observable<FloorPlanItem> {
    if (!data.id) {
      throw new Error('Id is required.')
    }

    const _data: CreateUpdateFloorPlanItemRequest = {
      type: data.type,
      name: data.name,
      attributes: data.getAttributes(),
    } as unknown as CreateUpdateFloorPlanItemRequest;

    return this.http.put<FloorPlanItem>(`${this.basePath}/${data.id}`, _data);
  }

  deleteById(id: string): Observable<FloorPlanItem | null> {
    return this.http.delete<FloorPlanItem | null>(`${this.basePath}/${id}`);
  }
}
